export const TitleText = [
    'Our platform is supported by a highly skilled curation team with a deep-rooted passion for art.',
    'This expertise allows us to create a thoughtfully selected collection of quality artwork and playlists. When you subscribe to our Textura Pro Standard you gain access to advanced playlists tailored to your specific industry, as well as contemporary artwork.'
]